import { ISODate } from './Leads';

export enum EngagementsCancelReasons {
  CONTINUED_USAGE = 'continued_usage',
  NO_ANSWER = 'no_answer',
  REFUSED_FOREVER = 'refused_forever',
  REFUSED_TEMPORARILY = 'refused_temporarily',
  OTHER = 'other',
}


export enum TaskType {
  CALL = 'call',
  EMAIL = 'email',
  OTHER = 'other',
}
export enum EngagenemtFlowStatus {
  ACTIVE = 'active',
  CLOSED = 'closed',
}
export enum EngagenemtStatus {
  ACTIVE = 'active',
  CLOSED = 'closed',
}

export type EngagementsDetails = {
  success: boolean;
  id: number;
  user_id: number;
  user: {
    id: number;
    firstName: string;
    lastName: string | null;
    telegram: string | null;
    email: string;
    photo: string | null;
  };
  createdAt: ISODate;
  updatedAt: ISODate;
  last_watched_at: ISODate;
  flows: [
    {
      id: number;
      engagementId: number;
      dataRows: [
        {
          id: number;
          engagementFlowId: number;
          task: string;
          taskType: TaskType;
          comment: null;
          deadline: ISODate;
          createdAt: ISODate;
          updatedAt: ISODate;
          files:
            | {
                name: string;
                url: string;
                size?: number;
                type?: string;
              }[]
            | null;
          stageStatus: EngagenemtFlowStatus;
        },
      ];
      createdAt: ISODate;
      updatedAt: ISODate;
      stageStatus: EngagenemtFlowStatus;
      position: number;
    },
  ];
  status: EngagenemtStatus;
  sourceMeta: {
    ad_id: string;
    ad_name?: string;
    adset_id?: string;
    adset_name?: string;
    campaign_id?: string;
    campaign_name?: string;
    created_time?: string;
    form_id?: string;
    form_name?: string;
    id: string;
    is_organic?: string;
    lead_status?: string;
    platform?: string;
  } | null;
  cancel_reason?: EngagementsCancelReasons | null;
  cancel_comment?: string | null;
  closed_at?: ISODate | null;
};
export type ActionsStageFlowData = {
  id: number;
  engagementId: number;
  dataRows: [
    {
      id: number;
      engagementFlowId: number;
      task: string;
      taskType: TaskType;
      comment: null;
      deadline: ISODate;
      createdAt: ISODate;
      updatedAt: ISODate;
      files:
        | {
            name: string;
            url: string;
            size?: number;
            type?: string;
          }[]
        | null;
      stageStatus: EngagenemtFlowStatus;
    },
  ];
  createdAt: ISODate;
  updatedAt: ISODate;
  stageStatus: EngagenemtFlowStatus;
  position: number;
};
export type EngagedDataRow = {
  id: number;
  engagementFlowId: number;
  task: string;
  taskType: TaskType;
  comment: null;
  deadline: ISODate;
  createdAt: ISODate;
  updatedAt: ISODate;
  files:
    | {
        name: string;
        url: string;
        size?: number;
        type?: string;
      }[]
    | null;
  stageStatus: EngagenemtFlowStatus;
};
